package com.patronat.top.dto.venues

import kotlinx.serialization.Serializable

@Serializable
enum class VenueStatus {
    ON_MODERATION,      // На модерації
    APPLICATION,        // Заявка
    CONNECTED,          // Підʼєднано
    REJECTED,           // Відхилено
    ADDED_BY_MODERATOR, // Додав модератор
    CHECK_CHANGES,      // Перевірити зміни
    CLOSED,             // Закритий
    DRAFT               // Черновик
}
